/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "auth": {
            "nested": {
              "AuthorizationError": {
                "values": {
                  "DEFAULT_ENUM_DO_NOT_USE": 0,
                  "INVALID_EXPIRATION": 1,
                  "INVALID_ACCOUNT": 2,
                  "BLACKLISTED_ACCOUNT": 3,
                  "CURRENCY_MISMATCH": 4,
                  "INSUFFICIENT_FUNDS": 5,
                  "MERCHANT_MISMATCH": 6,
                  "MERCHANT_INSUFFICIENT_PERMISSIONS": 7,
                  "LOCATION": 8,
                  "TRANSACTION_LIMIT": 9,
                  "OTHER": 10,
                  "INVALID_EXPIRATION_YEAR": 11,
                  "INVALID_EXPIRATION_MONTH": 12,
                  "CARD_EXPIRED": 13,
                  "CVV_FAILURE": 14,
                  "AVS_FAILURE": 15,
                  "GATEWAY_TIME_OUT": 16,
                  "VOICE_FAILURE": 17,
                  "PAN_FAILURE": 18,
                  "EXPIRATION_FAILURE": 19,
                  "MERCHANT_BLOCKED_BY_RISK": 20,
                  "CARD_NOT_SUPPORTED": 21,
                  "CARDHOLDER_INSUFFICIENT_PERMISSIONS": 22,
                  "INVALID_REQUEST": 23,
                  "INVALID_PIN": 24,
                  "INVALID_POSTAL_CODE": 25,
                  "PAYMENT_BLOCKED_BY_RISK": 26,
                  "CHIP_INSERTION_REQUIRED": 27,
                  "ALLOWABLE_PIN_TRIES_EXCEEDED": 28,
                  "PAYMENT_DECLINED_BY_SHADOWBAN": 29,
                  "MANUALLY_ENTERED_PAYMENT_NOT_SUPPORTED": 30,
                  "NO_ROUTE_FOUND": 31,
                  "INVALID_FEES": 32,
                  "PAYMENT_LIMIT_EXCEEDED": 33,
                  "AUTHENTICATION_REQUIRED": 34,
                  "ASSET_BLOCKED": 35,
                  "PAYMENT_BLOCKED_BY_MERCHANT_CONFIGURED_RULE": 36,
                  "PAYMENT_BLOCKED_PRE_AUTH_BY_DECLINE_RATE_LIMIT": 37,
                  "PAN_BLOCKED_BY_MERCHANT": 38,
                  "CLIENT_IP_BLOCKED_BY_RISK": 39,
                  "BROWSER_FINGERPRINT_BLOCKED_BY_RISK": 40,
                  "OTHER_NON_TECHNICAL": 41,
                  "SUSPECTED_FRAUD": 42,
                  "ACCOUNT_CLOSED": 43,
                  "ACCOUNT_BLOCKED_BY_ISSUER": 44,
                  "CARD_BLOCKED_BY_RISK": 45,
                  "EMAIL_BLOCKED_BY_RISK": 46,
                  "PAN_BLOCKED_BY_RISK": 47,
                  "PAYMENT_AMOUNT_MISMATCH": 48,
                  "PAYMENT_BLOCKED_BY_TRAFFIC_REMEDIATION": 50,
                  "BIN_BLOCKED_BY_RISK": 51,
                  "ISSUER_INSTALLMENT_ERROR": 52,
                  "AVT_BLOCKED_BY_RISK": 53,
                  "JA3_BLOCKED_BY_RISK": 54,
                  "INELIGIBLE_FOR_PREAUTHORIZATION": 55,
                  "INTERNAL_ERROR": 56,
                  "READER_DECLINED": 57,
                  "POLICY_DECLINE": 58
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.auth?.nested?.AuthorizationError) {
  $root.addJSON(jsonData);
}

/**
 * The reason an authorization was declined, which may come from either Square's payment
 * stack or the issuing bank.
 *
 * SOURCE AuthorizationError @ squareup/payments/auth.proto at 10:1
 */
export const AuthorizationError = $root.lookupEnum('squareup.payments.auth.AuthorizationError').values;